import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { GeneralInput, GeneralButton } from 'sharedComponents';
import { useDispatch } from 'react-redux';
import './style.scss';
import { routes } from 'routes';
import UserCapabilityHelper from 'helpers/userCapabilityHelper';
import { MAX_INPUT_CHAR_LENGTH } from 'helpers/constants';

const AssetSearch = ({ searchAsset, onHide, assets, capabilities, clearConditionOverviewStore }) => {
    const userCapabilities = new UserCapabilityHelper(capabilities);
    const { t: translate } = useTranslation();
    const history = useHistory();
    const [assetSearchValue, setAssetSearchValue] = useState('');
    const dispatch = useDispatch();
    const setQueryParameter = (value) => {
        onHide();
        const valueWithoutSpace = value.trim();
        if (userCapabilities.hasConditionOverviewV2()) {
            history.push({
                pathname: routes.ConditionOverviewV2,
                search: new URLSearchParams({ assetId: valueWithoutSpace }).toString()
            });
            return;
        } else {
            history.push({
                pathname: routes.AssetDetails,
                search: new URLSearchParams({ assetId: valueWithoutSpace }).toString()
            });
            return;
        }
    };

    const clearQueryParameter = () => {
        history.push({
            pathname: history.location.pathname,
        });
    };

    return <div className='general-filter-asset-search'>
        <div className='general-filter-asset-search-label'>
            {translate('ABB.Powertrain.Frontend.generalFilterSearchAssetLbl')}
        </div>
        <div>
            <GeneralInput
                id='general-filter-asset-search'
                className='general-filter-asset-search-input'
                value={assetSearchValue}
                onChange={(value) => {
                    setAssetSearchValue(value);
                }}
                placeholder={translate('ABB.Powertrain.Frontend.generalFilterSearchAssetPlaceholder')}
                clearable={false}
                maxLength={MAX_INPUT_CHAR_LENGTH}
            />
        </div>
        <GeneralButton
            type='primary'
            text={translate('ABB.Powertrain.Frontend.assetSearchButton')}
            className='general-filter-asset-search-button'
            onClick={() => {
                if (assetSearchValue?.length) {
                    clearQueryParameter();
                    dispatch(clearConditionOverviewStore());
                    const valueWithoutSpace = assetSearchValue.trim();
                    searchAsset(
                        valueWithoutSpace,
                        assets,
                        () => setQueryParameter(valueWithoutSpace),
                        clearQueryParameter,
                        [],
                        history // PASSING HISTORY FOR NAVIGATION FROM LEGACY ID TO MICRO-SERVICE ID ON ASSET SEARCH FROM GENERAL FILTER
                    );
                }
            }}
            disabled={!assetSearchValue?.length}
        />
    </div>;
};

AssetSearch.propTypes = {
    searchAsset: PropTypes.func,
    onHide: PropTypes.func,
    assets: PropTypes.array,
    clearConditionOverviewStore: PropTypes.func
};

export default AssetSearch;
